import type React from "react";
import type { DocumentAnnotationViewProps } from "@/types";

const DocumentAnnotationView: React.FC<DocumentAnnotationViewProps> = ({ onBack }) => {
	return (
		<div className="min-h-screen surface-alt">
			<div className="flex items-center justify-center h-screen">
				<div className="text-center">
					<h2 className="text-2xl font-semibold text-primary mb-4">Document Annotation</h2>
					<p className="text-muted mb-6">Document annotation interface coming soon...</p>
					<button type="button" onClick={onBack} className="btn btn-secondary">
						Back
					</button>
				</div>
			</div>
		</div>
	);
};

export default DocumentAnnotationView;
